import MobileNav from '../plugins/mobileNavPlugin';

const menuHolder = document.querySelector('body');
const mobileNav = new MobileNav(menuHolder, {
  onShow() {
    //document.getElementById('header').scrollIntoView(true);
    mobileNav.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
  },
  onHide() {
    mobileNav.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  },
});

function initMobileNav() {
  mobileNav.init();
}

function initHeaderHeight() {
  let header = document.getElementById('header');

  if (!header) return;

  function setHeaderHeight() {
    let headerHeight = header.offsetHeight;
    document.querySelector(':root').style.setProperty('--header-height', headerHeight + 'px');
  }

  setHeaderHeight();

  window.addEventListener('resize', setHeaderHeight);
}

function initNavAnchor() {
  const navLinks = document.querySelectorAll('.main-nav__link');
  if (navLinks.length == 0) return;

  navLinks.forEach(navLink => {
    anchorLink(navLink);
  })

  function anchorLink(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      let navbarHeight = 0;
      if (window.innerWidth >= 1024) {
        navbarHeight = document.querySelector('.main-nav').offsetHeight;
      }
      let element = document.querySelector(link.getAttribute('href'));
      if (!element) return;
      const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({top: y, behavior: 'smooth'});
      mobileNav.hide();
    })
  }
}

export {initMobileNav, initHeaderHeight, initNavAnchor}
